/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  MenuItem,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "@redux/actions";
import withStyles from "@material-ui/core/styles/withStyles";
import axios from "axios";
import FundTable from "./EmployeeFundTable";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 450,
  },
  centerText: {
    textAlign: "center",
    paddingTop: "10%",
  },
});
const EmployeesFund = ({ classes }) => {

  const dispatch = useDispatch();
  const employees = useSelector((state) => state.employees.payload);

  const [employeeId, setEmployeeId] = useState("");
  const [employeeFundData, setEmployeeFundData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchingData, setFetchingData] = useState(false);

  useEffect(() => {
    if (isEmpty(employees)) {
      dispatch(fetchEmployees());
    }
  }, []);

  const fetchEmployeeFund = async () => {
    try {
      setFetchingData(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_API_URL}/employee-fund/employee/${employeeId}`
      );
      if (response?.data?.success) {
        setEmployeeFundData(response?.data?.payload?.fund_data);
      } else {
        setEmployeeFundData([]);
        toast.error(response?.data?.message)
      }
    } catch (error) {
      console.error("error in fetching employee fund", error);
    } finally {
      setFetchingData(false);
    }
  };

  return (
    <Box paddingBottom={5}>
      <ToastContainer />
      <Box style={mainContainer}>
        <TextField
          label="Select Employee"
          variant="standard"
          className={classes.textField}
          value={employeeId}
          onChange={(e) => {
            setEmployeeId(e.target.value);
          }}
          select
        >
          {loading && !employees?.length ? (
            <MenuItem style={loadingEmployees}>
              <CircularProgress />
            </MenuItem>
          ) : (
            employees?.map((employee, i) => {
              return (
                <MenuItem value={employee?._id} key={i}>
                  {`${employee?.first_name} ${employee?.last_name}`}
                </MenuItem>
              );
            })
          )}
        </TextField>
        {employeeId ? (
          <Button
            variant="contained"
            color="primary"
            onClick={fetchEmployeeFund}
          >
            Show fund
          </Button>
        ) : null}
      </Box>
      {fetchingData ? (
        <MenuItem style={fetchingFundloader}>
          <CircularProgress />
        </MenuItem>
      ) : (
        <>
          {employeeId && employeeFundData?.length > 0 ? (
            <FundTable employeeFundData={employeeFundData} />
          ) : (
            <div className={classes.centerText}>
              <Typography variant="h7" style={{ whiteSpace: "pre-line" }}>
                {`Please Select Employee to see fund details`}
              </Typography>
            </div>
          )}
        </>
      )}
    </Box>
  );
};

const loadingEmployees = {
  display: "flex",
  justifyContent: "center",
};

const mainContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
};

const fetchingFundloader = {
  display: "flex",
  justifyContent: "center",
  marginTop: "10%",
};

export default withStyles(styles)(EmployeesFund);
